/* eslint-disable max-len */

export default {
  translations: {
    global: {
      home: 'Home',
      sign_in: 'Sign in',
      sign_up: 'Sign up',
      error: 'Error message',
      send: 'Send',
      my_account: 'My account',
      book: 'Book',
      workshop: 'Workshop',
      my_reservations: 'My Reservations',
      my_infos: 'My account',
      my_invoices: 'My invoices',
      sign_out: 'Sign out',
      bikes: 'Bike Rental',
      storage: 'Free bike storage',
      rent_bike: 'Rent a bike',
      rent_storage_free: 'Rent a free bike storage',
      rent_storage: 'Rent a bike storage',
      insurance: 'Insurance',
      park: 'Bike storage',
      page_not_found: {
        title: 'Page not found',
        wording: 'Oops ! An error has slipped under your wheel.',
      },
      go_back: 'Go back',
      repair_and_overhaul: 'Repair and Overhaul',
      renewal: 'Renewal',
    },
    routes: {
      SIGN_IN: 'Sign in',
      SIGN_UP: 'Sign out',
      CONTACT: 'Contact',
      HOME: 'Home',
      MAIL_VALIDATION: 'Email address validation',
      FORGOTTEN_PWD: 'Forgotten password ?',
      CHANGE_PWD: 'Change password',
      MY_ACCOUNT: 'My account',
      MY_RESERVATIONS: 'My reservations',
      MY_INVOICES: 'My invoices',
      RENT_BIKE: 'Rent a bike',
      RENT_STORAGE: 'Rent a storage',
      RENT_PARK: 'Rent a park',
      WORKSHOP: 'Workshop',
    },
    splash: {
      loading: "Don't move, it pedals hard.",
    },
    error: {
      motif_utilisationIsMissing: 'Use reason is mandatory',
      wrongBookingToken: 'Your booking has expired',
      listeAttenteNotValid: 'Booking not valid',
      resaExpired: 'Your booking has expired',
      alreadyInQueue: 'You are already in the waiting list',
      invalidPasReservation: 'Invalid time, please select a valid booking time',
      notAvailableAccessoire: 'Accessories choosen are not availables',
      creneauUnavailable: 'slot not available',
      minDelaiReservation:
        'The selected start date is no longer available (minimum delay required). Please select another one.',
      default: 'A problem occurred',
      mandatoryField: 'This field is required',
      missingParameters: 'You have not filled all mandatory fields.',
      codeOrValidated: 'Please verify the information provided .Beware : you can only validate a code once.',
      alreadyAccount: 'You are already registered with this email, please sign in !',
      wrongCredentials: 'You have entered a wrong username or wrong password',
      unknownError: "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
      invalidOrExpiredToken: 'Your session is expired. Please login in.',
      missingToken: 'Your session is expired. Please login in.',
      emailNotValidated: 'You have not yet authorized your e-mail. Please check your inbox and login in.',
      expiredBooking: 'Your reseration has expired. Please do the reservation process again',
      noAvailability: 'No availability for the requested dates. Please change your reservation dates or try again',
      maxResaCapacity: 'You have reached the maximum reservation capacity for your account.',
      unknownUser: "It seems your e-mail address doesn't exist.",
      pleaseWait: 'You can only ask for a new password every 10 minutes.',
      passwordTooShort: 'Your password is too short.',
      passwordsDontMatch: "The password and it's confirmation don't match.",
      wrongResetCode: 'The link you are using seems broken.',
      resetCodeExpired: 'The link you are using seems broken, please try the password reset process again.',
      resetCodeAlreadyUsed:
        'You already have used this reset password link, please try the password reset process again.',
      wrongPayment: 'Wrong payment',
      wrongFileFormat: "Your file isn't png, pdf or jpeg file",
      deliveryPointClosed: 'Please respect the opening time of the delivery point !',
      mustBeAnAdult: 'Vous devez être majeur',
      invalidDate: 'Invalid date format',
      mandatory_voucher: 'Mandatory voucher',
      boursierIsMissing: 'Scolarship is missing',
      unavailableStartDate: 'The start date is unavailable. Please change your start date.',
      ibanIsEmpty: 'IBAN is mandatory',
      bicIsEmpty: 'BIC is mandatory',
    },
    home: {
      welcome: 'Welcome',
      no_resa: 'You had no reservation for now',
      on_tool: 'on the bike rental and deposit tool of the agglomeration of',
      locality: 'Saint-Quentin-en-Yvelines',
      subtitle_0: 'You have currently ',
      reservations: '{{ count }} reservation',
      reservations_plural: '{{ count }} reservations',
      subtitle_1: '',
    },
    sign_in: {
      please_sign_in: 'Please sign in',
      forgotten_pwd: 'Password forgotten ?',
      sign_up: 'Sign in',
      no_account: 'No account ?',
      forgotten_password: "We've send you an email to reset your password",
      pwd_reset_success: 'Your password has been reset !',
      pwd_change_success: 'Your password has been changed !',
      log_in: 'Se connecter ?',
    },
    sign_up: {
      privacy_policy: 'Consult <a href="{{ link }}" target="_blank">Privacy policy</a>',
      type_a_phone: 'At least one phone number must be specified.',
      type_all_phones: 'You should specify a phone and mobile phone number.',
      newsletter: 'I would like to receive information on about {{collectivityName}} (new features, news, ...)',
      already_an_account: 'Already an account ?',
      please_sign_up: 'Please sign up',
      nature: 'Nature',
      individual: 'Individual',
      association: 'Association',
      company: 'Company',
      administration: 'Administration',
      civility: 'Civility',
      mr: 'Mr',
      mrs: 'Mrs',
      firm: 'Firm',
      firm_or_asso: 'Firm / Association / School',
      last_name: {
        label: 'Last name',
        placeholder: 'Your last name',
      },
      first_name: {
        label: 'First name',
        placeholder: 'Your first name',
      },
      password_field: {
        label: 'Password',
        helper: '10 or more characters, 1 upper character, 1 lower character, 1 numeric et 1 special character.',
      },
      email: 'Email',
      password: 'Mot de passe',
      birthdate: 'Date de naissance',
      origin_country: "Pays d'origine",
      address: 'Adresse',
      full_address: 'Adresse complémentaire (optional)',
      zip: 'ZIP',
      city: 'City',
      country: 'Country',
      phone: 'Phone',
      mobile_phone: 'Mobile phone',
      email_error: 'This email is an incorrect format',
      password_error: '8 or more characters and only letters and capitals',
      password_requirements: 'Your password must contain 8 or more characters and only letters and capitals',
      sign_up_success:
        'Thank you for registering, you will receive an email that will allow you to validate your registration',
      copy_password: 'My password (confirmation)',
      my_pwd: 'My password',
      change_pwd_description:
        'For security reasons, at the first time you sign in, you have to change the password you\ve receive in email',
    },
    contact: {
      title: 'Contact',
      contact_us: 'Contact us',
      let_your_contact: 'Please contact us and let us your contact info so that we could answer you !',
      success: 'Your request has been sent !',
      input_label: 'Message sender :',
    },
    forgotten_pwd: {
      title: 'Forgotten password',
      description: "Don't worry, it happen all the time !",
      button: 'New password',
    },
    mail_validation: {
      title: 'Email verification',
      please_verify: 'Please enter your e-mail address and the security code you received via email',
      code: 'Code',
      verify: 'Verify',
      has_no_account: 'No account ?',
      forgotten_pwd: 'Password forgotten ?',
      email_validated: 'Your email address is validated, you can now log in !',
    },
    my_account: {
      update_infos: 'Edit Personal Details',
      infos_updated: 'Your personal details have been updated !',
      you_can_modify: 'You can edit your personal details here',
    },
    my_reservations: {
      dates: 'From {{ startDate }} to {{ endDate }}',
      inscription: 'Queue registration : on {{ date }} {{ article }}',
      unsubscribe: 'Unsubscribe',
      empl: 'Emplacement',
      no_contracts: 'No contract',
      consult_here: 'Consultez here your current and past reservations .',
      current_reservations: 'Current reservations ({{currentResa}})',
      past_reservations: 'Past reservations ({{pastResa}})',
      renew: 'Renew',
      checkout_link: 'End of rental inventory',
      unsubscribe_success: 'You have been unsubscribed from the waiting list queue',
    },
    my_invoices: {
      price_type: 'VAT',
      price_currency: '€',
      no_invoice: 'No current invoice',
      header_description: 'View all your invoices here',
      tab_title: 'Invoice',
      invoice: 'Invoice {{ numFacture }} ',
      security_deposit: '+ security deposit',
    },
    workshop: {
      title: 'Workshop',
      meet_at_workshop: 'Meet us at the workshop.',
      check_up:
        'Your bike needs a check up ? We offer a maintenance service including advices and answers to all the question you have about the maintenance of bike',
      opening_times: 'Opening Times',
      opening_hours: 'monday to fridy : 7.30AM - 12PM et 2PM - 7.30PM',
      saturday: 'saturday : 10AM - 1PM',
      street: '1 ter Place Charles de Gaulle',
      city: '78180 Montigny-le-Bretonneux',
      tel: 'Tel: {{ item }}',
      mail: 'Email: {{ item }}',
    },
    duration: {
      year: 'year',
      month: 'month',
      day: 'day',
      trimester: 'trimester',
    },
    renewal: {
      title: 'Renewal',
      subtitle: 'Renew your reservation',
      you_choose_a: 'You choose to renew your reservation with the tariff ',
      pdl_addr:
        'Thank you for going to the reception of {{ emplOrPdlName }} <br/>{{ emplOrPdlAddress }}<br /> to take your bike',
      type_renewal: ' - renewal',
    },
    resabike: {
      need_grt: 'You have to accept the General Rental Terms',
      read_grt: 'I have read and accept the General Rental Terms',
      read_grt_with_link:
        'I have read and accept the\u00a0<a href="{{ link }}" target="_blank">General Rental Terms</a>',
      book_a_bike: 'Book a bike',
      inscription_waiting_list: 'Inscription on waiting list',
      rental_prices: 'Rental prices for a bike ',
      standard: 'standard',
      choose_duration_price: 'Choose a location and a price ',
      choose_duration: 'Choose a location ',
      back: 'Back to the previous page',
      book: 'BOOK',
      description: 'We offer you different types of bikes.',
      select_title: 'Choisissez votre point de location :',
      select_accessories: 'Select your accessories :',
      pre_selected_accessories: 'Accessories selected for this renewal : ',
      no_tariff_for_accessories: 'Tariff not available for this renewal and his accessories.',
      accessories_renewal: 'Accessories :',
      accessories_used: 'Accessories used for this renewal :',
      select_holder: 'Veuillez sélectionner un point de location',
      bike_number: '{{bikeNumber}} vélos',
      park_number: '{{bikeNumber}} consignes',
      bikes: 'bikes',
      parks: 'parks',
      bike_disponibility: 'Number of items available : ',
      waiting_list_link: 'Join the waiting list',
      accessories_disponibility: 'Number of accessories available : ',
      bike_price: '{{bikePrice}} {{ devise }}',
      from_price: 'Price from :',
      secured_park: 'secured park emplacement',
      ttc_day: 'incl. taxes / day',
      ttc: 'VAT',
      other_price: '+ other prices',
      form_start_date: 'Start date',
      form_end_date: 'End date',
      form_duration_start: 'Please choose the day and time you would like to make an appointment to collect the bike :',
      you_choose_a: 'You choose a',
      you_choose_a_park: 'You choose a',
      iban: 'IBAN',
      bic: 'BIC',
      use_reason: 'Use reason',
      reason: 'Select the use reason',
      service_trial: 'Service trial',
      work: 'Work',
      hobbies: 'Hobbies',
      others: 'Others',
      status: 'Select the status',
      invalid_iban: 'Your IBAN is not valid',
      invalid_bic: 'Your BIC is not valid',
      duration: 'Duration',
      min: 'minimum',
      max: 'maximum',
      electric: 'You have an electric bike ?',
      of_rental: 'of rental for the chosen price :',
      selected_duration: 'Selected duration :',
      id_card: 'Proof of identity (ID card, driver licence)',
      RIB: 'Bank Account Identifier (for the penalty)',
      if_you_dont_have: "If you don't have these proofs, please come in agency.",
      please_give_IBAN: 'Please give your bank account information to ease your reservations :',
      process_payment: 'Proceed to payment',
      your_data_wont_saved: " (beware, your data won't be saved)",
      duration_price: '(so {{ price }} {{ devise }} VAT approximately)',
      you_choose: 'You choose : ',
      you_choose_accessories: 'You choose accessories : ',
      rental_is_to: 'This rental is to : ',
      total_cost: 'Total cost : ',
      total_price_accessories: 'Total price, with accessories : {{ price }} {{ devise }} incl. taxes',
      please_wait: 'Please wait...',
      wait_validation: 'Your payment is processing...',
      congratulation: 'Congratulation !',
      pay: 'Pay',
      recap_choice: 'you have chosen the model : ',
      recap_choice_v2: 'you have chosen the model : ',
      recap_location: 'This rental will be distributed at : ',
      recap_total: 'Total cost : ',
      recap_title: 'Recap',
      we_have_several_bikes: 'We suggest you several types of bikes.',
      we_have_several_parks: 'We suggest you several types of bike parks.',
      payment_invalid: 'Payment failed',
      select_article: 'Select this article',
      show_tariffs: 'Show tariffs',
      validate_reservation: 'Validate the reservation',
      finalize_reservation: 'Finalize my reservation',
      insurance_hook: 'Needs an insurance to prevent bike breakage ? Click here (new window)',
      clean_form: 'Click here to clean the form.',
      security_deposit: 'Security deposit cashed : {{ securityDepositAmount }} {{ devise }}',
      security_deposit_prices: 'Security deposit : {{ securityDepositAmount }} {{ devise }}',
      security_deposit_choose: ' + Security deposit',
      article_type: {
        consigne: 'bike storage',
        consignepark: 'free bike storage',
        velo: 'bike',
      },
      accept_cgl: 'I have read and accept ',
      register: 'Register',
    },
    resa_storage: {
      title_header: 'Book a parking spot',
      transport_card: {
        first_descr: 'A valid Navigo card is',
        second_descr: 'MENDATORY',
        third_descr: 'to access our secure parkings !! It is composed of 10 numbers',
        fourth_descr: '(with no letters)',
        fifth_descr: 'and displayed in your card',
      },
      transport_card_placeholder: 'Navigo number',
      transport_card_upload: 'Proof purchase of your Navigo card',
      btn_pay: 'Go to payment',
      invalid_transport_card: 'You card number is not valid',
      modal_transport_card: {
        link: 'Where is the number ?',
        title: 'Where to find the number ?',
        close: 'Close',
        first_descr: 'Indicate the number',
        second_descr: 'WITH NO SPACE AND NO LETTERS',
        third_descr: 'of your Navigo card (see the above)',
        fourth_descr: 'Example : for',
        fifth_descr: '0123456789',
      },
    },
    languages: {
      fr: 'FR 🇫🇷',
      en: 'EN 🇬🇧',
    },
    repair_overhaul: {
      breakdown_type: 'Breakdown type',
      prevent: 'I wish to benefit the overhaul',
      breakdown: 'I have a breakdown',
      stolen_bike: 'My bike has been stolen/lost',
      needs_info: 'I need some more information',
      gear: 'Gear identifier',
      issue_desc: 'Issue description',
      contact: 'Contact information',
      submit: 'Submit your request',
      submit_success: 'We have well received your request !',
      status: 'Select your status',
      student: 'Scolarship student',
      back_to_work: 'Back-to-work young people',
      validation_lead: 'Your request has been recorded on <b>id #{{ticketId}}</b>',
      validation_line_one: 'Keep preciously this ticket id !',
      validation_line_two: "We're going to get some more information soon",
    },
    waiting_list: {
      validation_lead: 'You have been placed on the waiting list. Your position : <b>{{ticketId}}</b>',
    },
  },
};
